export default {
  INITIAL: 'initial',
  REQUEST: 'request',
  SUCCESS: 'success',
  FAILURE: 'failure',
}



// WEBPACK FOOTER //
// ./src/store/utils/fetchStatus.js